import React, { useEffect, useState } from 'react';
import FirstStepOfFollowUps from './RegisterTemplatesForm/FirstStepOfFollowUps';
import SecondStepOfFollowUps from './RegisterTemplatesForm/SecondStepOfFollowUps';
import ThirdStepOfFollowUps from './RegisterTemplatesForm/ThirdStepOfFollowUps';
import FourthStepOfFollowUps from './RegisterTemplatesForm/FourthStepOfFollowUps';
import FifthStepOfFollowUps from './RegisterTemplatesForm/FifthStepOfFollowUps';
import SixthStepOfFollowUps from './RegisterTemplatesForm/SixthStepOfFollowUps';
import SevenStepOfFollowUps from './RegisterTemplatesForm/SevenStepOfFollowUps';
import EigthStepOfFollowUps from './RegisterTemplatesForm/EigthStepOfFollowUps';
import NineStepOfFollowUps from './RegisterTemplatesForm/NineStepOfFollowUps';
import { useDispatch, useSelector } from 'react-redux';
import TenStepOfFollowUps from './RegisterTemplatesForm/TenStepOfFollowUps';
import ElevenStepOfFollowUps from './RegisterTemplatesForm/ElevenStepOfFollowUps';
import TwelveStepOfFollowUps from './RegisterTemplatesForm/TwelveStepOfFollowUps';
import ThirteenStepOfFollowUps from './RegisterTemplatesForm/ThirteenStepOfFollowUps';
import FourteenStepOfFollowUps from './RegisterTemplatesForm/FourteenStepOfFollowUps';
import FifteenStepOfFollowUps from './RegisterTemplatesForm/FifteenStepOfFollowUps';
import SixteenStepOfFollowUps from './RegisterTemplatesForm/SixteenStepOfFollowUps';
import { getFollowupsSuggestionData } from 'store/slices';
import SeventeenStepOfFollowUps from './RegisterTemplatesForm/SeventeenStepOfFollowUps';
import EighteenStepOfFollowUps from './RegisterTemplatesForm/EighteenStepOfFollowUps';
import NineteenStepOfFollowUps from './RegisterTemplatesForm/NineteenStepOfFollowUps';
import TwentyStepOfFollowUps from './RegisterTemplatesForm/TwentyStepOfFollowUps';
import TwentyOneStepOfFollowUps from './RegisterTemplatesForm/TwentyOneStepOfFollowUps';

const RegistrationFollowUpsTemplatesForm = ({ props, paperData }) => {
  const { userDetails } = useSelector((state) => ({
    userDetails: state.student.userDetails,
  }));

  const dispatch = useDispatch();
  const [suggestionData, setSuggestionData] = useState({});

  const {
    // view: viewAccess,
    update: updateAccess,
    // delete: deleteAccess,
    create: createAccess,
  } =
    userDetails?.role_data?.find(
      (item) => item?.permission_name === 'Event Management'
    )?.sub_permission || {};
  const { values } = props;
  const isEdit = updateAccess === '1' || createAccess === '1';

  const fetchFollwupsSuggestionData = async () => {
    const payload = {
      event_id: paperData?.event_id,
      followups_stage: values?.followUps,
    };
    const response = await dispatch(getFollowupsSuggestionData(payload));
    if (response.status === 200) {
      setSuggestionData(response?.data);
    }
  };

  useEffect(() => {
    fetchFollwupsSuggestionData();
  }, [paperData?.event_id, values?.followUps]);

  const getFormComponent = (type) => {
    switch (type) {
      case 'Session name inclusion notification':
        return (
          <FirstStepOfFollowUps
            props={props}
            isEdit={isEdit}
            suggestionData={suggestionData}
          />
        );
      case 'Coupon or Voucher follow ups/early bird deadline':
        return (
          <SecondStepOfFollowUps
            props={props}
            isEdit={isEdit}
            suggestionData={suggestionData}
          />
        );
      case 'Publication Details Few slots left':
        return (
          <ThirdStepOfFollowUps
            props={props}
            isEdit={isEdit}
            suggestionData={suggestionData}
          />
        );
      case 'Session-Based Publication Opportunities and Conference Outcomes at [Conference Name]':
        return (
          <FourthStepOfFollowUps
            props={props}
            isEdit={isEdit}
            suggestionData={suggestionData}
          />
        );
      case 'Keynote speaker, session speaker notification':
        return (
          <FifthStepOfFollowUps
            props={props}
            isEdit={isEdit}
            suggestionData={suggestionData}
          />
        );
      case 'Agenda Page and Slot Allotment notification':
        return (
          <SixthStepOfFollowUps
            props={props}
            isEdit={isEdit}
            suggestionData={suggestionData}
          />
        );
      case 'Hall Ticket, Zoom link and Confirmation':
        return (
          <SevenStepOfFollowUps
            props={props}
            isEdit={isEdit}
            suggestionData={suggestionData}
          />
        );
      case 'Full Paper Follow-Up Email':
        return (
          <EigthStepOfFollowUps
            props={props}
            isEdit={isEdit}
            suggestionData={suggestionData}
          />
        );
      case 'Conference testimonials email with CPD':
        return (
          <NineStepOfFollowUps
            props={props}
            isEdit={isEdit}
            suggestionData={suggestionData}
          />
        );
      case 'Scope of the Research Notification':
        return (
          <TenStepOfFollowUps
            props={props}
            isEdit={isEdit}
            suggestionData={suggestionData}
          />
        );
      case 'Coupon or Voucher follow ups/early bird deadline - Set 2':
        return (
          <ElevenStepOfFollowUps
            props={props}
            isEdit={isEdit}
            suggestionData={suggestionData}
          />
        );
      case 'Coupon or Voucher follow ups/early bird deadline - Set 3':
        return (
          <TwelveStepOfFollowUps
            props={props}
            isEdit={isEdit}
            suggestionData={suggestionData}
          />
        );
      case 'Allotment of ISBN and ISSN Number':
        return (
          <ThirteenStepOfFollowUps
            props={props}
            isEdit={isEdit}
            suggestionData={suggestionData}
          />
        );
      case 'Visa-Free Projection':
        return (
          <FourteenStepOfFollowUps
            props={props}
            isEdit={isEdit}
            suggestionData={suggestionData}
          />
        );
      case 'Scholarships & Awards Notification':
        return (
          <FifteenStepOfFollowUps
            props={props}
            isEdit={isEdit}
            suggestionData={suggestionData}
          />
        );
      case 'Pre-Conference Webinar Announcement':
        return (
          <SixteenStepOfFollowUps
            props={props}
            isEdit={isEdit}
            suggestionData={suggestionData}
          />
        );
      case 'Refer Your Colleagues':
        return (
          <SeventeenStepOfFollowUps
            props={props}
            isEdit={isEdit}
            suggestionData={suggestionData}
          />
        );
      case 'Awards sales Follow up':
        return (
          <EighteenStepOfFollowUps
            props={props}
            isEdit={isEdit}
            suggestionData={suggestionData}
          />
        );
      case 'Proceedings book Sales Follow up':
        return (
          <NineteenStepOfFollowUps
            props={props}
            isEdit={isEdit}
            suggestionData={suggestionData}
          />
        );

      case 'Agenda Sales Follow up':
        return (
          <TwentyStepOfFollowUps
            props={props}
            isEdit={isEdit}
            suggestionData={suggestionData}
          />
        );

      case 'Final Thank You Email for unregistered participants':
        return (
          <TwentyOneStepOfFollowUps
            props={props}
            isEdit={isEdit}
            suggestionData={suggestionData}
          />
        );

      default:
        return (
          <div className="center-flex">
            Please select the value from the dropdown
          </div>
        );
    }
  };
  return <div className="row">{getFormComponent(values?.followUps)}</div>;
};

export default RegistrationFollowUpsTemplatesForm;
